import { Field } from 'react-final-form'
import RenderTextField from './RenderTextField';
import colorPalette from '~/theme/colorPalette.js';
import { css } from '@emotion/react'

const InputField = ({ id, name, placeholder, validate, css, onKeyUp, wrapperCss = null, ...custom }) => {
  return (
    <div css={[styledInput, wrapperCss]}>
      <Field
        id={id}
        name={name}
        placeholder={placeholder}
        validate={validate}
        component={RenderTextField}
        css={[inputForm, css]}
        onKeyUp={onKeyUp}
        {...custom}
        // onBlur={onBlur} // このせいでリアルタイムのバリデーションが効かなくなっている
      />
    </div>
  )
}
export default InputField;

const styledInput = css`
  text-align: right;
  margin: 0 .5rem 1rem 0;
  .error{
    font-size: 1.3rem;
    color: ${colorPalette.orange};
    font-weight: bold;
  }
  @media screen and (max-width: 425px){
    .error{ font-size: 1.3rem;}
  }

`;

const inputForm = css`
  background-color: ${colorPalette.background.lightgray};
  border-radius: 10px;
  &:before {
    border-bottom: none;
  }
  &:after {
    border-bottom: none;
  }
  input:-webkit-autofill {
    transition: background-color 5000s ease-in-out 0s !important;
  }
`;
